// extracted by mini-css-extract-plugin
export default {"loadingAnimation":"Loader_loadingAnimation__w4rTj","loadingAnimation-circle":"Loader_loadingAnimation-circle__AsGn4","container":"Loader_container__f-Dq5"};